/*
 * @Author: zj 
 * @Date: 2019-04-17 11:13:30 
 * @Last Modified by: shenlurong
 * @Last Modified time: 2020-09-16 18:40:19
 */

const getters = {
    userInfo: state => state.app.userInfo,
    token: state => state.app.token,
    indexNavAft: state => state.app.indexNavAft,
    companyInfo: state => state.app.companyInfo,
    departmentInfo: state => state.app.departmentInfo,
    rootDepartment: state => { return state.app.rootDepartment },
    userDetileInfo: state => state.app.userDetileInfo,
    myTaskId: state => state.app.myTaskId,
    statusAll: state => state.app.statusAll,
    statusPart: state => state.app.statusPart,
    reportDetail: state => state.app.reportDetail,
    isExistCompany: state => state.app.isExistCompany,
    scrollMain: state => state.app.scrollMain,
    taskDetile: state => state.app.taskDetile,
    scrollMain: state => state.app.scrollMain,
    searchMembers: state => state.app.searchMembers,
    aftPath: state => state.app.aftPath,
    corpId: state => state.app.corpId,
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js